import { Component, OnInit } from '@angular/core';
import { CookieConsentService } from '../services/cookie-consent.service';


@Component({
  selector: 'app-cookie-consent-banner',
  templateUrl: './cookie-consent-banner.component.html',
  styleUrls: ['./cookie-consent-banner.component.css']
})
export class CookieConsentBannerComponent implements OnInit {

  showBanner = false;

  constructor(private cookieService: CookieConsentService) {}

  ngOnInit(): void {
    // Force banner to never show
    this.showBanner = false;
  }

  acceptCookies(): void {
    this.cookieService.setConsent('accepted');
    this.showBanner = false;
  }

  rejectCookies(): void {
    this.cookieService.setConsent('rejected');
    this.showBanner = false;
  }
}
